import { useMemo } from 'react';

import './StationList.scss';
import StationListItem from './item/StationListItem';

export default function StationList({
                                        currentStation,
                                        setCurrentStation,
                                        routePoints,
                                        stationsInScope,
                                        activeFilters,
                                        context,
                                        yourPosition
                                    }) {
    const filteredStations = useMemo(() => {
        if (!activeFilters?.length) {
            return stationsInScope[context];
        }

        return stationsInScope[context].filter((station) => {
            const features = Object.values(station.features)
                .filter(val => typeof val === 'object')
                .map(item => Object.entries(item))
                .flat()
                .filter(([key, val]) => val && typeof val === 'boolean')
                .map(([key]) => key);

            const isAvia = station.is_avia;
            const isPartner = features.includes("partner");

            // Jeżeli oba filtry aktywne -> OR
            if (activeFilters.includes("is_avia_normal") && activeFilters.includes("partner")) {
                return isAvia || isPartner;
            }

            // Jeżeli tylko Avia
            if (activeFilters.includes("is_avia_normal")) {
                return isAvia && activeFilters.every(f =>
                    f === "is_avia_normal" || features.includes(f)
                );
            }

            // Jeżeli tylko Partner
            if (activeFilters.includes("partner")) {
                return isPartner && activeFilters.every(f =>
                    f === "partner" || features.includes(f)
                );
            }

            // Pozostałe przypadki
            return activeFilters.every(f => features.includes(f));
        });
    }, [activeFilters, stationsInScope, context]);

    return (
        <div className="station-list">
            <span className="station-list__head">Znaleziono na trasie: <strong>{filteredStations.length} stacji</strong></span>
            <div className="station-list__wrap">
                {filteredStations?.map(station => (
                    <StationListItem yourPosition={yourPosition} key={station.id} routePoints={routePoints} station={station} setCurrentStation={setCurrentStation} currentStation={currentStation} />
                ))}
            </div>
        </div>
    );
}
